var map = {
	"./optional": 589,
	"./optional.js": 589,
	"./test": 1608,
	"./test.js": 1608
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3390;



//////////////////
// WEBPACK FOOTER
// ./~/optional ^\.\/.*$
// module id = 3390
// module chunks = 0